<script setup>
import { reactive, ref } from "vue";
import FormInput from "./inputs/FormInput.vue";
const props = defineProps({ fields: Array, record: { type: Object, default: () => ({}) }, title: String, save: Function });
const emit = defineEmits(["saved", "cancel"]);
const draft = reactive(Object.fromEntries(props.fields.map(field => [field.key, props.record[field.key] ?? (field.type === "checkbox" ? false : "")])));
const error = ref("");
const busy = ref(false);
async function submit() {
  error.value = ""; busy.value = true;
  try {
    const result = await props.save(Object.fromEntries(Object.entries(draft).map(([key, value]) => [key, value === "" ? null : value])));
    emit("saved", result);
  } catch (e) { error.value = e.message; } finally { busy.value = false; }
}
</script>
<template>
  <section class="editor card">
    <h2>{{ title }}</h2><p v-if="error" role="alert" class="alert">{{ error }}</p>
    <form @submit.prevent="submit">
      <div class="form-grid"><FormInput v-for="field in fields" :key="field.key" v-model="draft[field.key]" v-bind="field" :disabled="busy" /></div>
      <div class="actions"><button class="primary" :disabled="busy">{{ busy ? "Enregistrement…" : "Enregistrer" }}</button><button type="button" :disabled="busy" @click="emit('cancel')">Annuler</button></div>
    </form>
  </section>
</template>
